var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "custom-table" }, [
      _c(
        "div",
        { staticClass: "row no-gutters custom-table__body" },
        [
          _vm._l(_vm.sortedPrograms(), function (program) {
            return [
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(
                      _vm._s(_vm.getTranslation("product-list-vue", "program"))
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 col-sm-6" }, [
                _c("div", {
                  staticClass: "custom-table__body--elem",
                  domProps: { innerHTML: _vm._s(_vm.programName(program)) },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(_vm._s(_vm.getTranslation("front", "quantity"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 col-sm-2 text-sm-right" }, [
                _c("div", { staticClass: "custom-table__body--elem" }, [
                  _vm._v(_vm._s(_vm.quantity(program))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(_vm._s(_vm.getTranslation("front", "price"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 col-sm-2 text-sm-right" }, [
                _c("div", { staticClass: "custom-table__body--elem" }, [
                  _vm._v(_vm._s(_vm.linePrice(program))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(_vm._s(_vm.getTranslation("front", "total"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 col-sm-2 text-sm-right" }, [
                _c("div", { staticClass: "custom-table__body--elem" }, [
                  _vm._v(
                    _vm._s(
                      _vm.priceFormat(
                        _vm.getProgramPrice(
                          program.id,
                          "",
                          _vm.licenceType,
                          program.product,
                          program[_vm.licenceType] * 3
                        ),
                        true
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "col-12 d-sm-none custom-table__separator",
              }),
            ]
          }),
          _vm._v(" "),
          _vm._l(_vm.sortedExistingPrograms(), function (program) {
            return [
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(
                      _vm._s(_vm.getTranslation("product-list-vue", "program"))
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 col-sm-6" }, [
                _c("div", {
                  staticClass: "custom-table__body--elem",
                  domProps: {
                    innerHTML: _vm._s(_vm.existingProgramName(program)),
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(_vm._s(_vm.getTranslation("front", "quantity"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 col-sm-2 text-sm-right" }, [
                _c("div", { staticClass: "custom-table__body--elem" }, [
                  _vm._v(_vm._s(program.quantity)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(_vm._s(_vm.getTranslation("front", "price"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 col-sm-2 text-sm-right" }, [
                _c("div", { staticClass: "custom-table__body--elem" }, [
                  _vm._v(
                    _vm._s(
                      _vm.priceFormat(
                        _vm.getProgramPrice(
                          program.program_id,
                          "",
                          _vm.licenceType,
                          program.product,
                          1 * 3
                        ),
                        true
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4 custom-table__title d-sm-none" },
                [
                  _c("div", { staticClass: "custom-table__title--elem" }, [
                    _vm._v(_vm._s(_vm.getTranslation("front", "total"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 col-sm-2 text-sm-right" }, [
                _c("div", { staticClass: "custom-table__body--elem" }, [
                  _vm._v(
                    _vm._s(
                      _vm.priceFormat(
                        _vm.getProgramPrice(
                          program.program_id,
                          "",
                          _vm.licenceType,
                          program.product,
                          program.quantity * 3
                        ),
                        true
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "col-12 d-sm-none custom-table__separator",
              }),
            ]
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }